import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Help } from '../Help/index.esm.js';
import 'react-i18next';
import '@skatteetaten/ds-buttons';
import '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "label": "LabelWithHelp-module_label__BX0em",
    "label_required": "LabelWithHelp-module_label_required__r4m3T",
    "srOnly": "LabelWithHelp-module_srOnly__vCvXR"
};

const LabelWithHelp = /*#__PURE__*/ forwardRef(({ id: idExternal, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, description, helpText, helpSvgPath, titleHelpSvg, htmlFor, hideLabel, showRequiredMark, children, onHelpToggle }, ref)=>{
    const uniqueLabelId = `labelId-${useId()}`;
    const labelId = idExternal ?? uniqueLabelId;
    const requiredMarkClassName = showRequiredMark ? styles.label_required : '';
    const hideLabelClassName = hideLabel ? styles.srOnly : '';
    const concatenatedClassName = `${styles.label} ${requiredMarkClassName} ${hideLabelClassName} ${className} ${classNames?.label ?? ''}`.trim();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx("label", {
                ref: ref,
                id: labelId,
                "data-testid": dataTestId,
                className: concatenatedClassName,
                lang: lang,
                htmlFor: htmlFor,
                children: children
            }),
            /*#__PURE__*/ jsx(Help, {
                className: classNames?.helpText,
                classNames: classNames,
                helpSvgPath: helpSvgPath,
                helpText: helpText,
                hideHelp: hideLabel,
                targetId: labelId,
                titleHelpSvg: titleHelpSvg,
                description: description,
                onHelpToggle: onHelpToggle
            })
        ]
    });
});
LabelWithHelp.displayName = 'LabelWithHelp';

export { LabelWithHelp };
